import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient, Session } from '@benzinga/session';
import { ETFsEnvironment } from './environment';
import { ETF, ETFsResponse, Fund, FundsResponse } from './entities';

export class ETFRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ETFsEnvironment).url, session);
  }

  getETFs(): SafePromise<{ data: ETFsResponse }> {
    const url = this.URL(`etfs`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  }

  getETF(id: number | string): SafePromise<{ data: ETF }> {
    const url = this.URL(`etfs/${id}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  }

  getFunds(): SafePromise<{ data: FundsResponse }> {
    const url = this.URL(`funds`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  }

  getFund(id: number | string): SafePromise<{ data: Fund }> {
    const url = this.URL(`funds/${id}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  }
}
